// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__1Nx6l","input":"TextArea_input__2xnBV","fadeIn":"TextArea_fadeIn__246HW","fadeOut":"TextArea_fadeOut__2rlJ9"};